<template>
  <div class="flex flex-col justify-between border border-dark-line rounded-xl overflow-hidden hover:border-accent">
    <div class="p-6">
      <img :src="slider.photo.path" alt="" class="rounded-lg drop-shadow-[0_15px_15px_rgba(0,0,0,0.3)]">
      <h1 class="text-center mt-4">{{ slider.name }}</h1>
      <div class="text-center mt-2 text-muted">
        <VBadge :type="slider.active ? 'success' : 'danger' ">
          {{ slider.active ? 'فعال' : 'غیرفعال' }}
        </VBadge>
      </div>
    </div>

    <div class="flex">
      <button class="flex justify-center py-4 w-full text-accent bg-accent/20" @click="editModal = true">
        ویرایش
        <PenIcon class="fill-accent mr-2"/>
      </button>

      <button class="flex justify-center py-4 w-full text-accent bg-accent/20" @click="deleteModal = true">
        حذف
        <TrashcanIcon class="fill-accent mr-2"/>
      </button>
    </div>
  </div>

  <ModalSlider
      :show="editModal"
      @click="editModal = !editModal"
      :slider="slider"
      @edited="edited"/>

  <ModalConfirm
      title="حذف"
      :text="`از حذف اسلایدر ${slider.name} مطمئن هستید ؟`"
      :show="deleteModal"
      @click="deleteModal = !deleteModal"
      @confirmed="deleteSlider"
      @rejected="deleteModal = false"
  />

</template>

<script>
import PenIcon from "@/components/Icons/PenIcon";
import VBadge from "@/components/General/VBadge";
import ModalSlider from "@/components/Modal/ModalSlider.vue";
import TrashcanIcon from "@/components/Icons/TrashcanIcon.vue";
import ModalConfirm from "@/components/Modal/ModalConfirm.vue";
import {deleteSlider} from "@/API/API";

export default {
  name: "SliderCard",
  components: {ModalConfirm, TrashcanIcon, ModalSlider, VBadge, PenIcon},
  emits: ['edited'],
  props: ['slider'],
  data() {
    return {
      editModal: false,
      deleteModal: false,
    }
  },
  methods: {
    edited(slider) {
      this.editModal = false
      this.$emit('edited', slider)
    },
    deleteSlider() {
      deleteSlider(this.slider.id)
          .then(() => this.$emit('deleted'))
          .catch(err => this.$helper.validationError(err, this.errors))
          .finally(() => this.deleteModal = false)
    }
  }
}
</script>

<style scoped>

</style>